import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  InputGroup,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";
import DeleteModal from "../../../Components/Common/DeleteModal";
import OrganizationService from "../../../services/OrderingServices/OrganizationService";
import OrgForm from "../component/OrgForm";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const Organization = () => {
  const [orgList, setOrgList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState();
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => `${row.name} `,
      cell: (row) => <>{row.name}</>,
      sortable: true,
    },
    {
      name: "Org Code",
      selector: (row) => row.orgCode,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => (
        <div>
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => {
              setAddModal(true);
              setSelectedOrg(row);
            }}
          >
            <i className="ri-edit-line" />
          </Button>
          {/* <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button> */}
        </div>
      ),
      center: true,
    },
  ];

  const fetchOrg = async () => {
    try {
      const pageSize = 100;
      const pageNumber = 1;
      setLoading(true);
      const response = await OrganizationService.getOrgList(
        pageNumber,
        pageSize
      );

      setOrgList(response.items);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchOrg();
  }, []);
  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = orgList.filter((pkg) => {
    // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);

    // Combine name, surname, email, and phone number into a single search context, handling undefined fields
    const searchContext = `${pkg?.orgName || ""} ${pkg?.orgCode || ""} ${
      pkg?.email || ""
    }`.toLowerCase();

    // Check if the filterText is included in any of the search context
    const matchesFilter = searchContext.includes(filterText.toLowerCase());

    return matchesFilter;
  });
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedOrg(item);
    toggleDeleteModal();
  };
  const handleDelete = async () => {
    if (selectedOrg) {
      try {
        await CustomerServices.delete(selectedOrg);
        setOrgList((prevList) =>
          prevList.filter((pkg) => pkg.id !== selectedOrg)
        );
        toast.success("Selected customer deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedOrg(null);
      }
    }
  };
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Organization List" pageTitle="Organization" />
      </div>
      <Row>
        <Col md={8} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by org name ,email and org code"
              value={filterText}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col>
        {/* <Col
          md={4}
          xs={12}
          className="d-flex justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success px-1 px-sm-2"
            onClick={() => setAddModal(true)}
          >
            + Add Customer
          </button>
        </Col> */}
      </Row>
      <Card>
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData}
          />
        </CardBody>
      </Card>
      <OrgForm
        modal={addModal}
        toggleModal={() => {
          setAddModal(false);
          setSelectedOrg(null); // Clear editing state when closing
        }}
        setOrgList={setOrgList}
        orgList={orgList}
        selectedOrg={selectedOrg}
        fetchOrg={fetchOrg}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedOrg} // Pass the selected item
      />
    </div>
  );
};

export default Organization;
